var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_5012)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_5012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1543 64C49.8274 64 64.1543 49.6731 64.1543 32C64.1543 14.3269 49.8274 0 32.1543 0C14.4812 0 0.154297 14.3269 0.154297 32C0.154297 49.6731 14.4812 64 32.1543 64Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_5012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.154 62.9336C49.238 62.9336 63.0874 49.0842 63.0874 32.0002C63.0874 14.9162 49.238 1.06689 32.154 1.06689C15.07 1.06689 1.2207 14.9162 1.2207 32.0002C1.2207 49.0842 15.07 62.9336 32.154 62.9336Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3129 56.0073L24.7383 19.2002H19.3545V44.7895H23.6616V24.6699L49.9319 58.6118C51.1173 57.8185 52.2466 56.9478 53.3129 56.0073Z",
    fill: "url(#paint0_linear_96_5012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3096 19.2002H41.043V44.8002H45.3096V19.2002Z",
    fill: "url(#paint1_linear_96_5012)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_5012",
    x1: 38.91,
    y1: 41.4224,
    x2: 51.5323,
    y2: 57.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_96_5012",
    x1: 43.1763,
    y1: 19.2002,
    x2: 43.1048,
    y2: 38.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_5012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.154297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextjs);
export default __webpack_public_path__ + "static/media/icon-nextjs.99e52b0c325ac587c21a7968f12a0b22.svg";
export { ForwardRef as ReactComponent };